/* Rule of 110 Asset Allocator — Ch. 22. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  class AssetAllocator {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = { age: +u.age || 17, rule: +u.rule || 110, port: +u.p || 1000 };
      this.render(); this.bind(); this.update();
    }
    render() {
      var s = this.state;
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            <div class="sim-field">
              <label class="sim-field__label"><span>Your age</span><span class="val" data-display="age">${s.age}</span></label>
              <input type="range" data-state="age" min="13" max="80" step="1" value="${s.age}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Portfolio size</span><span class="val" data-display="port">${fmt(s.port)}</span></label>
              <input type="range" data-state="port" min="100" max="100000" step="100" value="${s.port}">
            </div>
            <div class="sim-field">
              <span class="sim-field__label">Rule</span>
              <div class="sim-toggle" data-toggle="rule">
                <button data-val="100" class="${s.rule===100?'is-active':''}">100</button>
                <button data-val="110" class="${s.rule===110?'is-active':''}">110</button>
                <button data-val="120" class="${s.rule===120?'is-active':''}">120</button>
              </div>
            </div>
          </div>
          <div class="sim-results">
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:16px;">
              <div class="sim-result"><div class="sim-result-label" style="color:var(--yellow);">Stocks</div><div class="sim-result-primary" data-out="stocks">0%</div></div>
              <div class="sim-result"><div class="sim-result-label" style="color:var(--text-secondary);">Bonds</div><div class="sim-result-primary" data-out="bonds">0%</div></div>
            </div>
            <div class="sim-stack">
              <div class="sim-stack__seg" data-seg="stocks" style="background:var(--yellow); color:var(--bg);">Stocks</div>
              <div class="sim-stack__seg" data-seg="bonds"  style="background:var(--text-secondary); color:var(--bg);">Bonds</div>
            </div>
            <div class="sim-insight" data-out="advice"></div>

            <table class="sim-table">
              <thead><tr><th>Age</th><th>Stocks %</th><th>Bonds %</th></tr></thead>
              <tbody data-out="agetable"></tbody>
            </table>

            <div class="sim-insight">Why 110 not 100? People live longer now. At 65, you may need your portfolio to last 30+ more years.</div>
          </div>
        </div>`;
    }
    bind() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var l = this.el.querySelector(`[data-display="${k}"]`);
          if (l) l.textContent = (k === 'age') ? v : fmt(v);
          this.update();
        });
      });
      this.el.querySelectorAll('[data-toggle="rule"] button').forEach(b => {
        b.addEventListener('click', () => {
          this.state.rule = +b.dataset.val;
          this.el.querySelectorAll('[data-toggle="rule"] button').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          this.update();
        });
      });
    }
    update() {
      var s = this.state;
      var stocks = Math.max(0, Math.min(100, s.rule - s.age));
      var bonds  = 100 - stocks;
      var $ = q => this.el.querySelector(q);
      $('[data-out="stocks"]').textContent = stocks + '%';
      $('[data-out="bonds"]').textContent  = bonds + '%';
      this.el.querySelector('[data-seg="stocks"]').style.width = stocks + '%';
      this.el.querySelector('[data-seg="bonds"]').style.width  = bonds + '%';

      var stockCash = s.port * stocks / 100;
      var bondCash  = s.port * bonds / 100;
      $('[data-out="advice"]').innerHTML =
        `For your <strong>${fmt(s.port)}</strong> portfolio at age ${s.age}:<br>` +
        `<strong>${fmt(stockCash)}</strong> → S&amp;P 500 index ETF (e.g. ticker: VOO or SPY)<br>` +
        `<strong>${fmt(bondCash)}</strong> → Bond index fund (e.g. ticker: BND or AGG)`;

      var rows = [17, 25, 35, 50, 65].map(a => {
        var st = Math.max(0, Math.min(100, s.rule - a));
        return `<tr><td>${a}</td><td>${st}%</td><td>${100 - st}%</td></tr>`;
      }).join('');
      $('[data-out="agetable"]').innerHTML = rows;
      IT.url.write({ age: s.age, rule: s.rule, p: s.port });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new AssetAllocator('simulator-container'));
})();
